import type { HumanReviewRequestFilter } from './client';

type AdminIdentity = {
  userId?: string | null;
  sessionId?: string | null;
};

const identityKey = ({ userId, sessionId }: AdminIdentity) =>
  [userId ?? null, sessionId ?? null] as const;

export const adminAccessQueryKey = (identity: AdminIdentity) =>
  ['admin', 'access', ...identityKey(identity)] as const;

export const taskStatusQueryKey = (
  identity: AdminIdentity,
  originUrl: string | null
) => ['admin', 'task-status', ...identityKey(identity), originUrl] as const;

export const taskStatusPrefixKey = (identity: AdminIdentity) =>
  ['admin', 'task-status', ...identityKey(identity)] as const;

export const attemptActivitiesQueryKey = (
  identity: AdminIdentity,
  attemptId: string,
  includePayload: boolean
) =>
  [
    'admin',
    'attempt-activities',
    ...identityKey(identity),
    attemptId,
    includePayload,
  ] as const;

export const humanReviewRequestsQueryKey = (
  identity: AdminIdentity,
  filter: HumanReviewRequestFilter
) =>
  [
    'admin',
    'human-review-requests',
    ...identityKey(identity),
    filter.state,
    filter.subjectType,
    filter.priority,
    filter.decisionSource,
    filter.sort,
  ] as const;

export const humanReviewRequestsPrefixKey = (identity: AdminIdentity) =>
  ['admin', 'human-review-requests', ...identityKey(identity)] as const;

export const humanReviewRequestQueryKey = (
  identity: AdminIdentity,
  requestId: string | null
) =>
  [
    'admin',
    'human-review-request',
    ...identityKey(identity),
    requestId,
  ] as const;

export const humanReviewRequestPrefixKey = (identity: AdminIdentity) =>
  ['admin', 'human-review-request', ...identityKey(identity)] as const;
